var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlipBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 32.76 0 c -7.019 0 -14.294 1.128 -19.25 4.19 C 5.469 9.157 3.118 18.855 3.39 27.784 C 3.63 35.506 5.695 43.8 11.18 49.503 c 5.233 5.441 15.999 7.888 23.337 7.888 c 0.331 0 0.681 0.238 0.681 0.682 v 7.794 a 1.35 1.35 0 0 0 1.364 1.368 c 0.045 0 0.086 -0.008 0.129 -0.012 c 0.29 -0.026 0.545 -0.133 0.748 -0.304 c 3.699 -3.171 7.398 -6.395 10.966 -9.715 c 3.42 -3.183 7.294 -6.452 9.97 -10.262 c 5.645 -8.037 6.48 -19.398 4.61 -28.818 c -1.8 -9.063 -8.218 -14.964 -17.216 -16.842 C 42.066 0.508 37.47 0 32.76 0",
    fill: "#00c6d7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlipBalloon);
export default __webpack_public_path__ + "static/media/blip-balloon.f8793ddc028786ef42165207bd7796e2.svg";
export { ForwardRef as ReactComponent };